export const SIDEBAR_DEFAULT_WIDTH = 256;
export const SIDEBAR_MIN_WIDTH = 200;
export const SIDEBAR_MAX_WIDTH = 420;
export const SIDEBAR_COLLAPSED_WIDTH = 72;

export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'sidebar.collapsed';
export const SIDEBAR_WIDTH_STORAGE_KEY = 'sidebar.width';
